import script from "./RegLeftBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RegLeftBar.vue?vue&type=script&setup=true&lang=js"

import "./RegLeftBar.vue?vue&type=style&index=0&id=169f159c&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169f159c"]])

export default __exports__